import React, { useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { isPremiumOrPro } from '../../utils/SubUtils';
import LockedFeature from './LockedFeature';

const NewsItem = ({ item }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const content = item.content || '';
    const shouldTruncate = content.length > 250;
    
    const displayContent = isExpanded || !shouldTruncate 
        ? content 
        : content.slice(0, 250) + '...';

    return (
        <div className="custom-card border p-4 rounded-3 shadow-sm">
            <h5 className="mb-3 fw-bold ">
                {item.title || (item.sentiment === 'positive' || item.sentiment === 'slightly positive' ? 'Positive Outlook' : (item.sentiment === 'negative' || item.sentiment === 'slightly negative' ? 'Concerns Raised' : 'Market Update'))}
            </h5>
            
            <div className=" mb-3">
                <span dangerouslySetInnerHTML={{__html: displayContent}}></span>
                {shouldTruncate && (
                    <span 
                        className=" cursor-pointer ms-2 fw-medium" 
                        style={{cursor: 'pointer'}}
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? 'Read less' : 'Read more'}
                    </span>
                )}
            </div>

            {isExpanded && item.content2 && (
                <div className="mt-3" dangerouslySetInnerHTML={{__html: item.content2}}></div>
            )}

            <div className="d-flex align-items-center small mt-2">
                <i className="fa fa-calendar me-2"></i>
                <span>{moment(item.date).format('MMM D, YYYY')}</span>
                <span className="mx-2">•</span>
                <span>{moment(item.date).fromNow()}</span>
            </div>
        </div>
    );
};



const IntelligenceUpdates = ({ data }) => {
    const user = useSelector((state) => state.auth.user);
    const subscription = user?.user_subscription;
    const isPro = isPremiumOrPro(subscription);

    if (!isPro) {
        return (
            <LockedFeature 
                title="Updates Locked" 
                description={<span>Upgrade to <strong>Premium or Pro</strong> plan to unlock positive outlook and market updates.</span>} 
            />
        );
    }

    if (!data || data.length === 0) return <div className="text-center p-5">No updates available.</div>;

    return (
    <div className="intelligence-updates-feed mt-4 px-3">
      <div className="d-flex flex-column gap-3">
        {data.map((item, index) => (
            <NewsItem key={index} item={item} />
        ))}
      </div>
    </div>
  );
};

export default IntelligenceUpdates;